<script>
import Validate from '@/prototype/src/validate'
export default {
  name: 'UtilsMixin',
  computed: {
    // 網上購買實體課程 (Hidden 課程"顯示於網頁")
    gDisableCourseToOnline() {
      return this.isAppMode(['T01', 'T02', 'T13'])
    },
    // Hidden course grade (for 未apply 組別管理 - 不需要組別 嘅CMS)
    gDisableCourseGrade() {
      return this.isAppMode([
        'T26',
        'T27',
        'T29',
        'T37',
        'T41',
        'T42',
        'T43',
        'T44',
        'T45',
        'T46',
        'T48',
        'T49',
        'T50',
        'T52',
        'T53',
        'T54',
      ])
    },
    // Course code required, otherwise, hidden the course code
    gDisableEmptyCode() {
      return this.isAppMode(['T01'])
    },
    // Hidden 課程進度
    gDisableLessonProgress() {
      return this.isAppMode(['T01'])
    },
    // 只可上載一張payment record, otherwise, can upload multiple payment record
    gDisableMultiplePaymentImg() {
      return this.isAppMode(['T01'])
    },
    // Setting不分分校
    gDisableSettingByCenter() {
      return this.isAppMode(['T01', 'T03', 'T04', 'T11', 'T14', 'T16', 'T17'])
    },
    // Hidden student account related
    gDisableStudentAccount() {
      /*
       * ! 要喺 payment_link_controller.php > GetAccountDomain() 加返 `$hidden_account = true;`
       */
      return this.isAppMode(['T03', 'T17'])
    },
    // Hidden student center
    gDisableStudentCenter() {
      return this.isAppMode(['T02'])
    },
    // when search student, ignore center filter
    gDisableStudentCenterFilter() {
      return this.gDisableStudentCenter || this.isAppMode(['T21', 'T51'])
    },
    // Hidden student grade
    gDisableStudentGrade() {
      return this.isAppMode(['T27'])
    },
    // Hidden upgrade button (for 未apply 組別管理 - 可以升組別 嘅CMS)
    gDisableStudentUpgrade() {
      return this.isAppMode([
        'T02',
        'T11',
        'T12',
        'T13',
        'T15',
        'T16',
        'T17',
        'T18',
        'T22',
        'T27',
        'T31',
        'T32',
        'T34',
        'T35',
        'T36',
        'T38',
        'T39',
        'T44',
        'T55',
      ])
    },
    // auto generate courses when create course category (hidden course pages)
    gEnableAutoGenCourse() {
      return this.isAppMode(['DEV', 'UAT', 'T16', 'T21', 'T25', 'T26', 'T27', 'T29', '33+']) && !this.isAppMode(['T40', 'T65'])
    },
    // 組別管理
    gEnableCustomGrade() {
      /*
       * ! T56或之前嘅CMS如果變成有組別管理，要喺register_template.php到remove返個grade
       */
      return this.isAppMode(['DEV', 'UAT', 'T25', 'T40', '56+'])
    },
    // coupon
    gEnableCoupon() {
      return !this.isAppMode(['T01'])
    },
    // 課堂出席狀態 - 請假/待處理
    gEnableLessonLeaveStatus() {
      return this.isAppMode(['DEV', 'UAT', 'T02', 'T21', 'T37', 'T46', 'T50'])
    },
    // 課程進度 (可上載影片)
    gEnableLessonProgressVideo() {
      return this.isAppMode(['DEV', 'UAT', 'T04', 'T43'])
    },
    // Log record
    gEnableLog() {
      return this.isAppMode(['DEV', 'UAT', 'T32', 'T37', 'T42', 'T45', 'T46', '61+'])
    },
    // 月票
    gEnableMonthPass() {
      /*
       * ! 現時backend須import T_common_trial
       */
      return this.isAppMode(['DEV', 'UAT', 'T44', 'T52', 'T57', '61+'])
    },
    // 積分
    gEnablePointSystem() {
      return this.isAppMode(['DEV', 'UAT', 'T11'])
    },
    // 恆常班一期堂數
    gEnableRegularPeriod() {
      return this.isAppMode(['DEV', 'UAT', 'T11', 'T28', 'T36', 'T47'])
    },
    // 兄弟姊妹
    gEnableSibling() {
      return this.isAppMode(['DEV', 'UAT', 'T21', 'T25', '38+'])
    },
    // 學生multiple分校
    gEnableStudentMultiCenter() {
      return this.isAppMode(['DEV', 'UAT', 'T36'])
    },
    // 請假申請
    gEnableTutorLeave() {
      return this.isAppMode(['DEV', 'UAT', 'T38', 'T46'])
    },
    // Product 入倉紀錄 & 商品銷售report
    gEnableWarehouse() {
      /*
      !! Fetcher.js 入面個parseProductData() 都要同步返 !!
      !! T65之前嘅CMS要fix返個cost先可以apply，否則個cost計出黎會唔岩
      */
      return this.isAppMode(['DEV', 'UAT', 'T59', '64+'])
    },
    // Tutor account只可檢視自己所屬的lesson
    gTutorViewOwnLessonOnly() {
      return true
    },
  },
  methods: {
    isAppMode(modes = []) {
      return Validate.isAppMode(this.$appMode, modes)
    },

    gfCheckSchoolSelected(leave = false) {
      const selectedSchool = this.gfGetUserSelectedSchool()

      if (selectedSchool > -1) return true

      this.$store.dispatch('showAlert', {
        message: 'message.accountNoCenter',
        isError: true,
        returnLink: leave ? 'SchoolList' : null,
      })
      return false
    },

    gfCheckRule(check) {
      return check === true ? true : this.$t(check)
    },

    async gfSortCourseOptions(courses = []) {
      const gradeOptions = this.$store.getters.gradeOptions
      const categoryIds = []
      for (let i = 0; i < courses.length; i++) {
        const found = categoryIds.find(el => el.id === courses[i].category_id)
        if (found) {
          if (found.courses[courses[i].grade]) {
            found.courses[courses[i].grade].push(courses[i])
          } else {
            found.courses['_null'].push(courses[i])
          }
        } else {
          let obj = {
            id: courses[i].category_id,
            color: courses[i].category_data ? courses[i].category_data.color || '' : '',
            courses: {},
          }
          for (let j = 0; j < gradeOptions.length; j++) {
            obj.courses[gradeOptions[j].value] = []
          }
          obj.courses['_null'] = []

          if (obj.courses[courses[i].grade]) {
            obj.courses[courses[i].grade].push(courses[i])
          } else {
            obj.courses['_null'].push(courses[i])
          }

          categoryIds.push(obj)
        }
      }
      categoryIds.sort((a, b) => b.id - a.id)

      const options = []
      for (let i = 0; i < categoryIds.length; i++) {
        for (const grade in categoryIds[i].courses) {
          for (let j = 0; j < categoryIds[i].courses[grade].length; j++) {
            const course = categoryIds[i].courses[grade][j]
            const foundGrade = gradeOptions.find(el => el.value === course.grade)
            options.push({
              value: course.id,
              text: this.$formatter.generateCourseTitle(course, gradeOptions),
              name: course.name,
              grade: course.grade,
              grade_name: foundGrade ? foundGrade.text : course.grade,
              color: categoryIds[i].color,
              category_id: course.category_id
            })
          }
        }
      }
      return options
    },

    gfGetOptionsByKey(key) {
      switch (key) {
        case 'admission_source':
          return this.$sourceOptions
        case 'special':
          return this.$specialCaseOptions || []
        case 'grade':
          return this.$store.getters.gradeOptions
        case 'school_time':
          return [
            { value: 'am', text: this.$t('schoolTimeOption.am') },
            { value: 'pm', text: this.$t('schoolTimeOption.pm') },
            { value: 'all', text: this.$t('schoolTimeOption.all') },
          ]
        case 'location':
          return this.$regionOptions || []
        case 'gender':
          return this.$genderOptions
        case 'member_level':
          return this.$memberOptions
        case 'special_remind':
        case 'agree_video':
        case 'is_membership':
        case 'have_football_shirt':
        case 'have_participate_competition':
        case 'ever_enrolled':
        case 'agree_promo':
        case 'join_course':
          return [
            { value: true, text: this.$t('true') },
            { value: false, text: this.$t('false') },
          ]
        case 'enroll_reason':
          return this.$enrollReasonOptions || []
        case 'school_type':
          return this.$schoolTypeOptions || []
        case 'nation':
          return this.$nationOptions || []
        case 'know_from':
          return this.$knowFromOptions || []
        case 'belong':
          return this.$belongOptions || []
        case 'job_class':
          return this.$joinClassOptions || []
        case 'join_newbie_passion':
          return [
            { value: true, text: this.$t('joinNewbiePassionOptions.paid') },
            { value: false, text: this.$t('joinNewbiePassionOptions.unpaid') },
          ]
        case 'send_leave_notify':
          return [
            { value: 'N', text: this.$t('sendLeaveNotifyOptions.N') },
            { value: 'sent', text: this.$t('sendLeaveNotifyOptions.sent') },
            { value: 'Y', text: this.$t('sendLeaveNotifyOptions.Y') },
          ]
        case 'weapon_hand':
          return [
            { value: 'left', text: this.$t('left') },
            { value: 'right', text: this.$t('right') },
          ]
        default:
          return []
      }
    },

    // -------------- Order Related
    gfParseOrderData(el) {
      let qty = 0
      let items = []

      const lessonGroup = []
      const lessonDatas =
        el.pdf_order_data && el.pdf_order_data.lesson_datas ? el.pdf_order_data.lesson_datas : el.lesson_datas
      if (lessonDatas.length) {
        lessonDatas.forEach(item => {
          const related = lessonGroup.find(
            temp => temp[0].course_name === item.course_name && temp[0].course_code === item.course_code,
          )
          if (related) {
            related.push(item)
          } else {
            lessonGroup.push([item])
          }
        })
      }
      if (el.order_type.includes('course')) {
        lessonGroup.forEach(item => {
          const _item = item.sort((a, b) => this.$formatter.sortDate(a.date, b.date))
          const list = _item.map(
            elm =>
              `${elm.date.substring(8, 10)}/${elm.date.substring(5, 7)}(${this.$d(
                this.$formatter.convertDate(elm.date),
                'weekdayShort',
              )})`,
          )
          items.push({ name: item[0].course_name, details: list.join(', ') })
        })

        qty += lessonDatas.length
      } else if (el.order_type.includes('package')) {
        el.package_datas.forEach(item => {
          if (!items.find(el => el.package_id === item.id)) {
            items.push({ name: item.name, package_id: item.id })
          }
        })

        if (el.unpaid_lesson_datas.length) {
          el.unpaid_lesson_datas.forEach(item => {
            const related = lessonGroup.find(
              temp => temp[0].course_name === item.course_name && temp[0].course_code === item.course_code,
            )
            if (related) {
              related.push(item)
            } else {
              lessonGroup.push([item])
            }
          })
        }
        const list = lessonGroup.map(item => {
          const _item = item.sort((a, b) => this.$formatter.sortDate(a.date, b.date))
          const lessons = _item.map(
            elm =>
              `${elm.date.substring(8, 10)}/${elm.date.substring(5, 7)}(${this.$d(
                this.$formatter.convertDate(elm.date),
                'weekdayShort',
              )})`,
          )

          return `${item[0].course_name} (${lessons.join(', ')})`
        })
        items[items.length - 1]['details'] = list.join(', \n')

        qty += el.package_list.length
      } else if (el.order_type.includes('online_course')) {
        if (el.online_course_data) {
          items.push({ name: el.online_course_data.name })
        }
        qty += 1
      } else if (el.order_type.includes('month_pass')) {
        el.month_pass_datas.forEach(item => {
          if (!items.find(el => el.month_pass_id === item.id)) {
            items.push({ name: item.name, month_pass_id: item.id })
          }
        })

        qty += el.month_pass_list.length
      }

      if (el.order_type.includes('product')) {
        el.product_datas.forEach(item => {
          items.push({ name: item.name })
        })

        qty += el.product_list.reduce((count, item) => count + item.amount, 0)
      }

      if (el.order_type.includes('custom')) {
        el.custom_items.forEach(item => {
          items.push({ name: item.name })
        })

        qty += el.custom_items.reduce((count, item) => count + item.amount, 0)
      }

      if (el.order_type.includes('skip')) {
        el.skip_lessons_data.forEach(item => {
          items.push({
            name: item.course_name,
            details: `${item.date.substring(8, 10)}/${item.date.substring(5, 7)}(${this.$d(
              this.$formatter.convertDate(item.date),
              'weekdayShort',
            )})`,
          })
        })
        qty += el.skip_lessons.length
      }

      let total_price_text = ''
      if (el.is_redeem) {
        total_price_text = `${this.$formatter.separator(el.subtotal)} (${this.$t('pointsName')})`
      } else {
        total_price_text = `HK$${this.$formatter.separator(el.subtotal)}`
        if (el.status === 'void') {
          total_price_text = this.$t('orderCancelled')
        } else if (el.status === 'debit') {
          total_price_text = `HK$${this.$formatter.separator(el.subtotal - el.debit_amount)}`
          total_price_text += this.$t('refundedRemark', { refund: el.debit_amount })
        }
      }

      return {
        ...el,
        order_id: el.id,
        order_items: items,
        qty: qty,
        total_price: total_price_text,
        refund: el.status === 'debit',
        order_code: '',
        approver: '',
      }
    },

    /**
     * DN-[order id]
     * T21: [YYYYMM(order create_date)][student_code][order lesson code(if have)]-[0000(第幾張order係有呢個lesson)]
     */
    gfGenerateOrderId(order) {
      return new Promise(async (resolve, reject) => {
        if (order && order.id !== undefined) {
          if (this.$validate.DataValid(order.custom_invoice_number) && order.custom_invoice_number) {
            resolve(order.custom_invoice_number)
          } else {
            if (this.isAppMode(['T21']) && order.create_date) {
              let code = `${order.create_date.substring(0, 4)}${order.create_date.substring(5, 7)}${order.student_code}`
              const lessonDatas =
                order.pdf_order_data && order.pdf_order_data.lesson_datas
                  ? order.pdf_order_data.lesson_datas
                  : order.lesson_datas
              if (this.$validate.DataValid(lessonDatas, true)) {
                code += lessonDatas[0].course_code

                try {
                  const { data } = await this.$Fetcher.GetOrders({
                    filter_item: [
                      { key: 'create_date', value: order.create_date.substring(0, 7) },
                      { key: 'student_id', value: order.student_id },
                    ],
                    sort_dir: 'asc',
                    order_by: 'id',
                  })

                  const filters = data.filter(el => {
                    const _lessonDatas =
                      el.pdf_order_data && el.pdf_order_data.lesson_datas
                        ? el.pdf_order_data.lesson_datas
                        : el.lesson_datas
                    return (
                      this.$validate.DataValid(_lessonDatas, true) &&
                      _lessonDatas[0].course_code === lessonDatas[0].course_code
                    )
                  })
                  for (let i = 0; i < filters.length; i++) {
                    if (filters[i].id === order.id) {
                      code += `-${this.$formatter.pad(i + 1, 4)}`
                      break
                    }
                  }
                } catch (err) {
                  if (err === 'abort') {
                    resolve('abort')
                  }
                }
              }
              resolve(code)
            } else {
              resolve(`DN-${order.id}`)
            }
          }
        } else {
          resolve('')
        }
      })
    },

    gfGetUserMonthPass(orders) {
      const allData = []
      const lessonDates = []
      const monthPassOrders = orders.filter(item => item.order_type.includes('month_pass') && item.status === 'paid')
      for (let i = 0; i < monthPassOrders.length; i++) {
        let obj = {
          id: monthPassOrders[i].id,
          dates: [],
        }

        let days = 0
        let months = 0
        for (let j = 0; j < monthPassOrders[i].month_pass_list.length; j++) {
          const found = monthPassOrders[i].month_pass_datas.find(
            el => el.id === monthPassOrders[i].month_pass_list[j].id,
          )
          if (found) {
            if (found.type === 'days') {
              days += found.days
            } else if (found.type === 'months') {
              months += 1
            }
          }
        }
        if (months > 0) {
          if (monthPassOrders[i].month_pass_selected_months.length) {
            monthPassOrders[i].month_pass_selected_months.sort((a, b) => this.$formatter.sortDate(`${a}-01`, `${b}-01`))

            let tempMonth = ''
            let startDate = null
            let count = 0
            for (let j = 0; j < monthPassOrders[i].month_pass_selected_months.length; j++) {
              let nowMonth = ''
              if (j === 0) {
                startDate = this.$formatter.convertDate(`${monthPassOrders[i].month_pass_selected_months[j]}-01`)
                nowMonth = monthPassOrders[i].month_pass_selected_months[j]
              } else {
                const _nowMonth = this.$formatter.convertDate(`${tempMonth}-01`)
                _nowMonth.setMonth(_nowMonth.getMonth() + 1)
                nowMonth = `${_nowMonth.getFullYear()}-${this.$formatter.pad(_nowMonth.getMonth() + 1)}`
              }

              if (nowMonth === monthPassOrders[i].month_pass_selected_months[j]) {
                count += 1
              }

              // 如果係最後一個month / 月份與上一個不相連，加end date
              if (
                j === monthPassOrders[i].month_pass_selected_months.length - 1 ||
                nowMonth !== monthPassOrders[i].month_pass_selected_months[j]
              ) {
                const endDate = this.$formatter.convertDate(
                  `${startDate.getFullYear()}-${this.$formatter.pad(startDate.getMonth() + 1)}-01`,
                )
                endDate.setMonth(endDate.getMonth() + count)
                endDate.setDate(0)
                obj.dates.push({
                  start_date: this.$formatter.formatDate(startDate),
                  end_date: this.$formatter.formatDate(endDate),
                })
                startDate = this.$formatter.convertDate(`${monthPassOrders[i].month_pass_selected_months[j]}-01`)
                count = 1

                // 如果係最後一個又唔相連，加end date
                if (
                  j === monthPassOrders[i].month_pass_selected_months.length - 1 &&
                  nowMonth !== monthPassOrders[i].month_pass_selected_months[j]
                ) {
                  const endDate2 = this.$formatter.convertDate(
                    `${startDate.getFullYear()}-${this.$formatter.pad(startDate.getMonth() + 1)}- 01`,
                  )
                  endDate2.setMonth(endDate.getMonth() + count)
                  endDate2.setDate(0)
                  obj.dates.push({
                    start_date: this.$formatter.formatDate(startDate),
                    end_date: this.$formatter.formatDate(endDate2),
                  })
                }
              }

              tempMonth = monthPassOrders[i].month_pass_selected_months[j]
            }
          }
        } else if (days > 0 && monthPassOrders[i].lesson_datas.length) {
          const lessons = monthPassOrders[i].lesson_datas.sort((a, b) => this.$formatter.sortDate(a.date, b.date))

          let startDate = this.$formatter.convertDate(lessons[0].date)
          startDate.setHours(12, 0, 0)
          let endDate = this.$formatter.convertDate(lessons[0].date)
          endDate.setHours(12, 0, 0)
          endDate.setDate(endDate.getDate() - 1 + days)
          obj.dates.push({
            start_date: this.$formatter.formatDate(startDate),
            end_date: this.$formatter.formatDate(endDate),
          })
        }
        allData.push(obj)
      }

      for (let i = 0; i < allData.length; i++) {
        for (let j = 0; j < allData[i].dates.length; j++) {
          const startDate = this.$formatter.convertDate(allData[i].dates[j].start_date)
          const endDate = this.$formatter.convertDate(allData[i].dates[j].end_date)
          while (this.$validate.isDateLess(startDate, endDate)) {
            lessonDates.push(this.$formatter.formatDate(startDate))
            startDate.setDate(startDate.getDate() + 1)
          }
          lessonDates.push(this.$formatter.formatDate(endDate))
        }
      }
      lessonDates.sort((a, b) => this.$formatter.sortDate(a, b))
      return {
        list: allData,
        dates: lessonDates,
      }
    },

    // -------------- Grade Related
    gfGetGradeText(grade) {
      const gradeOptions = this.$store.getters.gradeOptions || []
      const foundGrade = gradeOptions.find(el => el.value === grade)
      if (foundGrade) {
        return foundGrade.text
      }

      return grade
    },

    // check hidden course grade
    gfCheckDisabledCourseGrade(setting) {
      // 如果唔係自動gen course嘅CMS，唔可以disable lesson grade
      if (!this.gEnableAutoGenCourse) return false

      if (this.gEnableCustomGrade && this.$validate.DataValid(setting)) {
        // 如果 `need_grade` 係undefined，default有course grade
        if (!this.$validate.DataValid(setting.need_grade)) {
          return false
        } else {
          return !setting.need_grade
        }
      }

      return this.gDisableCourseGrade
    },

    // -------------- Copy function
    gfCopyText(text) {
      return new Promise(async (resolve, reject) => {
        try {
          if (typeof text === 'string') {
            await navigator.clipboard.writeText(text)
          } else {
            const clipboardItem = new ClipboardItem({
              'text/plain': text,
            })
            await navigator.clipboard.write([clipboardItem])
          }
          this.$store.dispatch('toggleSnack', {
            message: 'message.copied',
            type: 'success',
          })
          resolve(true)
        } catch (err) {
          this.$common.error(err)
          resolve(false)
        }
      })
    },
    async gfGetCopiedText() {
      try {
        // Request permission to read from the clipboard (if not already granted)
        const permissionStatus = await navigator.permissions.query({ name: 'clipboard-read' })

        if (permissionStatus.state === 'granted' || permissionStatus.state === 'prompt') {
          const text = await navigator.clipboard.readText()
          return text
        } else {
          console.warn('Clipboard read permission denied or not supported.')
          return ''
        }
      } catch (err) {
        this.$common.error(err)
        return ''
      }
    },

    // -------------- Open link function
    gfOpenWindow(call) {
      return new Promise(async (resolve, reject) => {
        const newWindow = window.open('', '_blank')
        if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
          this.$store.dispatch('toggleSnack', { message: 'message.popupBlocked', type: 'error' })
          resolve(false)
          return
        }

        const url = await call()
        if (url) {
          newWindow.location.href = url
          resolve(true)
        } else {
          newWindow.close()
          resolve(false)
        }
      })
    },

    gfGetDownloadPDFLink(file, filename = '') {
      return `https://tutordev-api.innpressionhost.com/pdf-dl.php?url=${this.$mediaPath}${file}&name=${filename || file}`
    },

    // -------------- Format function
    gfConvertDuration(second) {
      const obj = {
        hour: 0,
        min: 0,
        second: 0,
      }
      let rest = second
      obj.hour = Math.floor(rest / (60 * 60))
      rest -= obj.hour * (60 * 60)
      obj.min = Math.floor(rest / 60)
      obj.second = rest - obj.min * 60

      if (obj.hour > 0) {
        if (obj.min > 0 || obj.second > 0) {
          if (obj.second > 0) {
            return this.$t('durationFormat.hms', obj)
          } else {
            return this.$t('durationFormat.hm', obj)
          }
        } else {
          return this.$t('durationFormat.h', obj)
        }
      } else if (obj.min > 0) {
        if (obj.second > 0) {
          return this.$t('durationFormat.ms', obj)
        } else {
          return this.$t('durationFormat.m', obj)
        }
      } else {
        return this.$t('durationFormat.s', obj)
      }
    },

    gfSalaryLevelName(level) {
      const found = this.$salaryLevelOptions.find(el => el.value === level)
      if (found) return found.text
      return level
    },

    // -------------- Table List function
    gfGetTableQuery(keyObj) {
      let returnObj = {}

      const query = this.$route.query
      for (let key in keyObj) {
        if (this.$validate.DataValid(query[key])) {
          let value = query[key]
          if (Array.isArray(keyObj[key])) {
            if (keyObj[key].length < 1 || !keyObj[key].includes(value)) {
              value = null
            }
          } else {
            switch (keyObj[key]) {
              case 'int':
                if (this.$validate.regexNumber(value)) {
                  value = parseInt(value)
                } else {
                  value = null
                }
                break
              case 'float':
                if (this.$validate.regexFloating(value)) {
                  value = parseFloat(value)
                } else {
                  value = null
                }
                break
              case 'date':
                if (!this.$validate.regexDateStr(value)) {
                  value = null
                }
                break
              case 'year_month':
                if (!this.$validate.regexYearMonth(value)) {
                  value = null
                }
                break
              case 'array_int':
                const intList = []
                const intSplit = value.split(',')
                for (let i = 0; i < intSplit.length; i++) {
                  if (this.$validate.regexNumber(intSplit[i])) {
                    intList.push(parseInt(intSplit[i]))
                  }
                }
                value = intList
                break
              case 'array_string':
                const strList = []
                const strSplit = value.split(',')
                for (let i = 0; i < strSplit.length; i++) {
                  if (this.$validate.DataValid(strSplit[i])) {
                    const s = strSplit[i].trim()
                    if (!strList.includes(s)) {
                      strList.push(s)
                    }
                  }
                }
                value = strList
                break
            }
          }

          if (this.$validate.DataValid(value)) {
            returnObj[key] = value
          }
        }
      }

      return returnObj
    },
  },
}
</script>
